// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".simple-modal-wrapper{background:#fff;position:fixed;top:0;left:0;z-index:1050;height:100%;width:100%;display:none;overflow-y:scroll}.close-modal{position:absolute;top:0;right:35px;color:#777;font-size:50px;font-weight:700;cursor:pointer;transition:all .35s ease}.close-modal:hover{color:#333}.simple-modal-dialog{width:100%;max-width:1060px}", ""]);
// Exports
module.exports = exports;
